import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

import { updatePaint } from '../../../../../actions/orders'

// Styles
import './index.scss'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../../../utils/auth'
import { translation } from '../../../../../utils/helpers'

// Elements
import LabelWrapper from '../../../../../shared/elements/labelWrapper'
import Text from '../../../../../shared/elements/text'
import Icon from '../../../../../shared/elements/icon'
import Inline from '../../../../../shared/elements/inline'
import Check from '../../../../../shared/elements/check'

import { ColorIcons } from '../../../../../shared/elements/icons'

class Color extends Component {

  constructor (props) {
    super(props)
    this.state = {
      color: undefined
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.setState({
      color: {
        Color: this.props.item.Color,
        ColorCode: this.props.item.ColorCode,
        ColorVariant: this.props.item.ColorVariant,
        ColorAmount: this.props.item.ColorAmount,
        ColorIsReady: this.props.item.ColorIsReady
      }
    })
  }

  componentWillReceiveProps (nextProps) {
    let data = {
      Color: nextProps.item.Color,
      ColorCode: nextProps.item.ColorCode,
      ColorVariant: nextProps.item.ColorVariant,
      ColorAmount: nextProps.item.ColorAmount,
      ColorIsReady: nextProps.item.ColorIsReady
    }
    if (!isEqual(data, this.state.color)) {
      this.setState({
        color: data
      })
    }
    if (this.nextProps !== undefined && this.nextProps.checkForPopups !== undefined) this.nextProps.checkForPopups()
  }

  onInputChange (e) {
    e.persist()
    this.setState({
      color: {
        ...this.state.color,
        [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : e.target.value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur()
      }
    })
  }

  onBlur () {
    let data = { ...this.state.color }
    data.OrderId = this.props.id
    this.props.updatePaint(data).then((res) => {
      this.props.updateOrder(res.data)
      // Toastr
      // window.toastr.success(translation('13521'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  render () {
    if (this.state.color === undefined) return null
    let isNotCustomer = !hasAccess([4], this.props.auth.user.UserType)
    if (this.props.auth.departmentType === 1) {
      // Dette er hvad vi viser, hvis vi er logget ind som pladeværksted/Karosseri
      return (
        <div className='poppedup padding colorInlinePopup form'>
          <LabelWrapper labelText={translation('179')}>
            <Inline block fillChildNum={[1]} spacing={0}>
              <Icon icon={ColorIcons.Color_Name} />
              <Text size='m' name='Color' value={this.state.color.Color || ''} onChange={this.onInputChange} onBlur={this.onBlur} />
            </Inline>
          </LabelWrapper>
          <LabelWrapper labelText={translation('79')}>
            <Inline block fillChildNum={[1]} spacing={0}>
              <Icon icon={ColorIcons.Color_Code} />
              <Text size='m' name='ColorCode' value={this.state.color.ColorCode || ''} onChange={this.onInputChange} onBlur={this.onBlur} />
            </Inline>
            <div style={{ clear: 'both' }} />
          </LabelWrapper>
        </div>
      )
    } else {
      // Dette er hvad vi viser, hvis vi er logget ind som lak-/integrationsværksted
      return (
        <div className='poppedup padding colorInlinePopup form'>
          <LabelWrapper labelText={translation('179')}>
            <Inline block fillChildNum={[1]} spacing={0}>
              <Icon icon={ColorIcons.Color_Name} />
              <Text size='m' name='Color' value={this.state.color.Color || ''} onChange={this.onInputChange} onBlur={this.onBlur} />
            </Inline>
          </LabelWrapper>
          <LabelWrapper labelText={translation('79')}>
            <Inline block fillChildNum={[1]} spacing={0}>
              <Icon icon={ColorIcons.Color_Code} />
              <Text size='m' name='ColorCode' value={this.state.color.ColorCode || ''} onChange={this.onInputChange} onBlur={this.onBlur} />
            </Inline>
          </LabelWrapper>
          {hasSubscriptionPermission(this.props.auth, 10) && isNotCustomer && ([
            <LabelWrapper labelText={translation('13388')} key='color_1'>
              <Inline block fillChildNum={[1]} spacing={0}>
                <Icon icon={ColorIcons.Color_Variant} />
                <Text size='m' name='ColorVariant' value={this.state.color.ColorVariant || ''} onChange={this.onInputChange} onBlur={this.onBlur} />
              </Inline>
            </LabelWrapper>,
            <LabelWrapper labelText={translation('13392')} key='color_2'>
              <Inline block fillChildNum={[1]} spacing={0}>
                <Icon icon={ColorIcons.Color_Amount} />
                <Text size='m' name='ColorAmount' value={this.state.color.ColorAmount || ''} onChange={this.onInputChange} onBlur={this.onBlur} />
              </Inline>
            </LabelWrapper>,
            <LabelWrapper labelText={translation('13393')} key='color_3'>
              <Inline block fillChildNum={[1]} spacing={0}>
                <Icon icon={ColorIcons.Color_Ready} />
                <Check size='m' simple id='ColorIsReady_input' name='ColorIsReady' value={this.state.color.ColorIsReady} onChange={this.onInputChange} checked={this.state.color.ColorIsReady} />
              </Inline>
            </LabelWrapper>
          ])}
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  updatePaint
})(Color)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/Color/index.js